import { getMasked } from './imask';
import { dateTimeHumanReadableFromISO } from '../Helpers/dates';

export function getMaskedValue({ value, type, mask }): { value: any; type?: string; mask?: any } {
    if (mask && typeof mask !== 'string') {
        return getMasked(mask, value);
    }

    const maskType = mask ? mask : type;

    if (maskType) {
        const masked = getDefaultMask(maskType);

        if (!masked) {
            return value;
        }

        if (typeof masked === 'function') {
            return masked(value);
        }

        return getMasked(masked, value);
    }

    return value;
}

export function getDefaultMask(type): { type: string } {
    return defaultMaskValues[type];
}

export const defaultMaskNames = [
    { id: 'datetime', name: 'Datetime' },
    { id: 'number', name: 'Number' },
    { id: 'price', name: 'Price' },
];

const defaultMaskValues = {
    datetime: (value) => dateTimeHumanReadableFromISO(value),
    number: {
        mask: 'Number',
        thousandsSeparator: ' ',
    },
    price: {
        mask: 'NUM Kč',
        lazy: false,
        blocks: {
            NUM: {
                mask: 'Number',
                thousandsSeparator: ' ',
            },
        },
    },
    file: (value) => {
        return `<img src="${value.url}" class="w-14 h-auto"/>`;
    },
};
